import { useEffect, useState } from 'react'
import { Box } from '@mui/system'

import { useUserContext } from '../../auth/UserProvider'
import {
  useShippingsTracking,
  useShippingStates,
} from '../../services/shippingsTracking'
import DrawerWrapper from '../../ui/modules/DrawerWrapper'

import useHomeFilters from './useHomeFilters'
import ShippingsSearch from './ShippingsSearch'
import ShippingsSummary from './ShippingsSummary'

import HomeView from './View'

import useStyles from './styles'

const Home = () => {
  const classes = useStyles()

  const {
    isLoading: isLoadingUserData,
    centres,
    clientCode,
    statusList,
    auditData,
    webUserName,
  } = useUserContext()

  const { tabValue, filters, handleChangeView } = useHomeFilters({
    centres,
    clientCode,
    sortType: 'desc',
    sortColumn: 'shippingDate',
  })

  const queryConfig = { enabled: filters?.clientCode !== undefined }

  const { isLoading: isLoadingShippings, data: shippingsData } =
    useShippingsTracking({ filters, statusList, config: queryConfig })

  const shippingCodes =
    shippingsData?.shippings?.map(item => item.info.shippingCode) || []

  const { data: shippingsStates, isLoading: isLoadingShippingsStates } =
    useShippingStates(shippingCodes)

  const [incidentBeingSolved, setIncidentBeingSolved] = useState(null)
  const isIncidentDrawerOpen = Boolean(incidentBeingSolved)
  const handleCloseIncidentWidget = () => setIncidentBeingSolved(null)

  useEffect(() => {
    document.addEventListener(
      'incident-solver:general:close',
      handleCloseIncidentWidget,
    )

    return () => {
      document.removeEventListener(
        'incident-solver:general:close',
        handleCloseIncidentWidget,
      )
    }
  }, [])

  const areShippingsEmpty =
    !isLoadingShippings && shippingsData?.shippings.length === 0

  return (
    <Box className={classes.root}>
      <HomeView
        isLoading={isLoadingUserData}
        username={webUserName}
        noData={areShippingsEmpty}
      >
        <ShippingsSearch onClickResolveIncident={setIncidentBeingSolved} />
        <ShippingsSummary
          tabValue={tabValue}
          onChangeView={handleChangeView}
          filters={filters}
          shippingsData={shippingsData}
          states={shippingsStates}
          isLoadingShippings={isLoadingShippings}
          isLoadingShippingsStates={isLoadingShippingsStates}
          onClickResolveIncident={setIncidentBeingSolved}
        />
      </HomeView>
      <DrawerWrapper
        isOpen={isIncidentDrawerOpen}
        onClose={handleCloseIncidentWidget}
      >
        <incident-solver
          incident-type-code={incidentBeingSolved?.incidentTypeCode}
          shipping-code={incidentBeingSolved?.shippingCode}
          process-code={auditData.process_code}
          user-code={auditData.user_code}
        />
      </DrawerWrapper>
    </Box>
  )
}

export default Home
